<template>
    <BaseModal v-if="evaluation" ref="modal" v-model="modalShow" size="lg">
        <h3>{{ evaluation.name }}</h3>
        <b-overlay :show="showOverlay" class="overlay">
            <div class="list-group">
                <div class="list-group-item" v-for="question in questions" :key="question.id">
                    <b>
                        {{ question.text }}
                    </b>
                    <br>
                    <div v-for="option in question.answers" :key="option.id" class="ms-2">
                        <span :class="option.correctAnswer ? 'bg-success text-light px-2 py-1 rounded' : 'px-2 py-1'">
                            {{ option.text }}
                        </span>
                    </div>
                </div>
            </div>
        </b-overlay>
    </BaseModal>
</template>

<script>
import { EventNames } from '@/plugins/enums';
import { mapActions } from 'vuex'
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: "EvaluationQuestions",

    components: {
        BaseModal,
    },

    data() {
        return {
            questions: [],
            evaluation: null,
            modalShow: false, 
        }
    },

    computed: {
        showOverlay() {
            return this.questions.length === 0
        }
    },

    mounted() {
        this.$eventBus.$on(EventNames.OpenEvaluationQuestionsModal, async (evaluation) => {
            this.evaluation = evaluation
            this.modalShow = true
            await this.getQuestions()
        })
    },

    methods: {
        ...mapActions(["getEvaluationById"]),

        async getQuestions() {
            let result = await this.getEvaluationById({evaluationId: this.evaluation.id})
            if (result.isError) {
                this.$refs.modal.showAlertExternal(result.message, 'danger')
                this.modalShow = false
            }

            this.questions = result.data[0].questions
        }
    },

    watch: {
        modalShow(newValue) {
            if (!newValue) {
                this.questions = []
                this.evaluation = null
            }
        }
    }
}
</script>

<style scoped>
.overlay {
   min-height: 100px;
}
</style>